<template>
  <div v-if="!($route.path === '/' && !$route.name)">
    <layout-full v-if="layout === 'full'" />
    <layout-im v-else-if="layout === 'im'" />
    <layout-default v-else />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import jwt_decode from 'jwt-decode';
import Storage from '@/utils/storage';
import * as API_Passport from '@/api/passport';
import * as API_Members from '@/api/members';
import Cookies from 'js-cookie'
export default {
  name: 'App',
  components: {
    LayoutDefault: () => import('./layouts/default'),
    LayoutFull: () => import('./layouts/full'),
    LayoutIm: () => import('./layouts/im')
  },
  data() {
    return {
      flag:1,
    }
  },
  watch: {
    // TODO:
    '$route.query': {
      handler(newValue) {
        // this.flag++
        console.log("app---route",this.$route);
        console.log('$route.query@@@', newValue);
        // alert(this.flag)
        console.log("query.from",newValue.from, typeof(newValue.from));
        console.log("query.logout",newValue.logout, typeof(newValue.logout));
        if (typeof(newValue.from) == "string") {

          if(newValue.from !== 'JRC') return
          localStorage.setItem("from", newValue.from)
        } else {
          if (! newValue.from) return
          localStorage.setItem("from", newValue.from[0])
          let temp1 = newValue.from.every(item => {
            return item == "JRC"
          })
          console.log('temp1', temp1);
          if (!temp1) {
            return
          }
        }
        // let data = {
        //   fromShop: true,
        //   formShopUrl: window.location.href,
        //   data: '子页面主动触发通讯app',
        //   fromHome:true
        // };
        // window.parent.postMessage(data, '*');
        
        
        
        // 金融村没登录,电商也不登录
        if (typeof(newValue.logout) == "string") {
          if (newValue.logout == 'true') {
            console.log("金融村没登录,电商也不登录1");
            this.logout().then(() => {
              this.cleanCartStore();
              // document.location.reload();
            });
          }
        } else {
          if (! newValue.logout) return
          let temp2 = newValue.logout.every(item => {
            return item == "true"
          })
          console.log('temp2', temp2);
          if (temp2) {
            console.log("金融村没登录,电商也不登录2");
            this.logout().then(() => {
              this.cleanCartStore();
              // document.location.reload();
            });
          }
        }
        // if (newValue.logout == 'true') {
        //   console.log("金融村没登录,电商也不登录");
        //   this.logout().then(() => {
        //     this.cleanCartStore();
        //     // document.location.reload();
        //   });
        // }
        if (!newValue.userName) return
        const { userName } = newValue
        let params = {
            uuid:  new Date().getTime(),
            syscode: '10003',
            account: userName,
          }
          console.log("金融村直连商城newValue.access_token",newValue.access_token);
          console.log("金融村直连商城newValue.refresh_token",newValue.refresh_token);
        localStorage.setItem("access_token", typeof(newValue.access_token) == "string"?newValue.access_token :newValue.access_token[1])
        localStorage.setItem("refresh_token", newValue.refresh_token)
        // this.setAccessToken(newValue.access_token);
        // this.setRefreshToken(newValue.refresh_token);
        API_Passport.loginNow(params)
        .then(async response => {
          console.log("金融村直连商城",response);
          localStorage.setItem("access_token", response.access_token)
          localStorage.setItem("refresh_token", response.refresh_token)
          this.setAccessToken(response.access_token);
          this.setRefreshToken(response.refresh_token);
          const expires = new Date(jwt_decode(response.refresh_token).exp * 1000);
          Storage.setItem('uid', response.uid, { expires });
          localStorage.setItem("loginNow", 1)
          await this.getUserData()
          await this.getCartData();
          // this.$router.push({
          //   path:localStorage.getItem('jrcToShopUrl')
          // })
        })
        .catch(e=>{
          console.log('e', e )
        });

      },
      immediate: true
    }
  },
  computed: {
    layout() {
      let layout = 'default'
      const routes = this.$route.matched
      if (routes.length === 0) return layout
      const matchedComponents = []
      for (let i = 0; i < routes.length; i++) {
        const route = routes[i]
        let component = route.components.default
        component = component.default || component
        matchedComponents.push(component)
      }

      for (let i = 0; i < matchedComponents.length; i++) {
        const com = matchedComponents[i]
        if (com.layout) {
          layout = com.layout
          break
        }
      }
      return layout
    }
  },
  mounted() {
    // window.addEventListener('message', e => {
    //   console.log('父页面传输过来参数', e);
    //   this.logout().then(() => {
    //     this.cleanCartStore();
    //     // document.location.reload();
    //   });
      
    // });
  },
  methods: {
    ...mapActions({
      login: 'user/loginAction',
      logout: 'user/logoutAction',
      cleanCartStore: 'cart/cleanCartStoreAction',
      getCartData: 'cart/getCartDataAction',
      setAccessToken: 'user/setAccessTokenAction',
      removeAccessToken: 'user/removeAccessTokenAction',
      setRefreshToken: 'user/setRefreshTokenAction',
      removeRefreshToken: 'user/removeRefreshTokenAction',
      getUserData: 'user/getUserDataAction',
    }),
  }
}
</script>
<style lang="scss">
body .el-table th.gutter {
  display: table-cell !important;
}

#wrapper {
  // background: linear-gradient(181deg,#dde0ee 0%, #efefef 100%);
  // background: #EFEFEF;
  min-height: calc(100vh - 31px - 219px);
  margin: auto;
  // width: 1210px;//商家展示问题 然后 注释了
  min-height: 500px;

  
}
.layui-layer-content  {
    min-height: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue